import React from "react";
import { Button, Input, Typography } from "antd";

const { Text } = Typography;

const AppointmentActionForm = ({
  actionType,
  inputRemark,
  setInputRemark,
  onCancel,
  onConfirmComplete,
  onConfirmCancel,
  className = "",
  style = {},
}) => {
  if (!actionType) return null;

  const isComplete = actionType === "complete";

  return (
    <div className={`appt-edit-form ${className}`} style={style}>
      <div style={{ marginBottom: "8px" }}>
        <Text strong className="form-label-mini" style={{ color: isComplete ? "#389e0d" : "#cf1322" }}>
          {isComplete ? "✓ ระบุผลการติดต่อ" : "✕ ระบุเหตุผลการยกเลิก"}
        </Text>
        <Input.TextArea
          value={inputRemark}
          onChange={(e) => setInputRemark(e.target.value)}
          placeholder={
            isComplete
              ? "ระบุรายละเอียดผลการติดต่อจากการนัดหมาย..."
              : "ระบุเหตุผลการยกเลิกนัดหมาย..."
          }
          rows={2}
          maxLength={200}
          className="form-input-rounded"
          style={{ marginTop: "4px" }}
        />
      </div>

      <div className="buttons-footer-sm">
        <Button size="small" onClick={onCancel} className="btn-rounded-sm">
          ยกเลิก
        </Button>
        <Button
          size="small"
          type="primary"
          danger={!isComplete}
          onClick={isComplete ? onConfirmComplete : onConfirmCancel}
          className="btn-rounded-sm"
          style={isComplete ? { background: "#389e0d", borderColor: "#389e0d" } : {}}
        >
          ยืนยัน
        </Button>
      </div>
    </div>
  );
};

export default AppointmentActionForm;
